
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { ArrowUpDown, Shield, ShieldOff, Trash2 } from "lucide-react";
import type { User } from "./types";
import type { SortField } from "./types";

interface UsersTableProps {
  users: User[];
  sortField: SortField;
  sortDirection: 'asc' | 'desc';
  onSort: (field: SortField) => void;
  onToggleAdmin: (userId: string, currentStatus: boolean) => void;
  onDeleteUser: (userId: string) => void;
}

export function UsersTable({
  users,
  sortField,
  sortDirection,
  onSort,
  onToggleAdmin,
  onDeleteUser,
}: UsersTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>
            <Button 
              variant="ghost" 
              onClick={() => onSort('email')}
              className="flex items-center gap-1"
            >
              E-mail
              <ArrowUpDown className="h-4 w-4" />
            </Button>
          </TableHead>
          <TableHead>
            <Button 
              variant="ghost" 
              onClick={() => onSort('created_at')}
              className="flex items-center gap-1"
            >
              Aangemaakt op
              <ArrowUpDown className="h-4 w-4" />
            </Button>
          </TableHead>
          <TableHead>
            <Button 
              variant="ghost" 
              onClick={() => onSort('last_sign_in_at')}
              className="flex items-center gap-1"
            >
              Laatste login
              <ArrowUpDown className="h-4 w-4" />
            </Button>
          </TableHead>
          <TableHead>Admin</TableHead>
          <TableHead>Acties</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {users.map((user) => (
          <TableRow key={user.id}>
            <TableCell>{user.email}</TableCell>
            <TableCell>
              {new Date(user.created_at).toLocaleDateString('nl-NL')}
            </TableCell>
            <TableCell>
              {user.last_sign_in_at
                ? new Date(user.last_sign_in_at).toLocaleDateString('nl-NL')
                : 'Nog niet ingelogd'}
            </TableCell>
            <TableCell>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onToggleAdmin(user.id, user.is_admin)}
                title={user.is_admin ? "Verwijder admin rechten" : "Maak admin"}
              >
                {user.is_admin ? (
                  <Shield className="h-4 w-4 text-green-600" />
                ) : (
                  <ShieldOff className="h-4 w-4 text-muted-foreground" />
                )}
              </Button>
            </TableCell>
            <TableCell>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => {
                  if (window.confirm('Weet je zeker dat je deze gebruiker wilt verwijderen?')) {
                    onDeleteUser(user.id);
                  }
                }}
                title="Verwijder gebruiker"
              >
                <Trash2 className="h-4 w-4 text-destructive" />
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
